
import { myFormat, propComparator } from '../utils/ui_utils';
import { ListItemIcon, MenuItem } from '@mui/material';
import { SendAndArchive } from '@mui/icons-material';
import { advance_data_entry, common_data_entry, other_data_entry, mother_data_entry, lifetime_data_entry } from '../definitions/cow';
import { common_data_entry as cowmancommon_data_entry } from '../definitions/cowman';
import { common_data_entry as propertycommon_data_entry } from '../definitions/property';

const getBirthData = (b) => {
    if (b) {
        return myFormat(b, 'dd/MM/yyyy')
    } else {
        return ''
    }

}


const getCategoryLabel = (c) => {
    if (c) {
        if (c.category_number < 8) {
            return 'M'
        } else {
            return 'V'
        }
    }

}
const ExportCSV = ({ data, fileName, title, cow_list }) => {
    const downloadCSV = (fm) => {
        // Convert the data array into a CSV string
        const end = fm === 'dos' ? '\r' : '\n'
        const csvString = [
            [title],
            ['PROPRIETARIO', 'NUMCAT', 'MATRICOLA SOG.', 'DATANASC.', 'RANK', 'CATEGORIA', 'pft'],
            ...data.filter(c => c.is_present).map(cow => [
                cow.property ? cow.property.cdaua : '',
                cow.catalog_id,
                cow.serial,
                getBirthData(cow.birthdate),
                cow.total_point,
                getCategoryLabel(cow.category),
                cow.pft
            ]) // Map your data fields accordingly
        ]
            .map(row => row.join(","))
            .join(end);
        // Create a Blob from the CSV string
        const blob = new Blob([csvString], { type: 'text/csv' });
        // Generate a download link and initiate the download
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'export_data.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    const mapdatacow_dict = Object.assign({}, ...[...common_data_entry, ...advance_data_entry, ...other_data_entry, ...lifetime_data_entry, ...mother_data_entry].filter(e => e.import_id).map((x) => ({ [x.id]: { label: x.import_id, type: x.type } })))
    const mapdatacowman_dict = Object.assign({}, ...[...cowmancommon_data_entry].filter(e => e.import_id).map((x) => ({ [x.import_id]: x })))
    const mapdataproperty_dict = Object.assign({}, ...[...propertycommon_data_entry].filter(e => e.import_id).map((x) => ({ [x.import_id]: x })))


    const downloadCowlistWithCatalog = (fm) => {
        const end = fm === 'dos' ? '\r' : '\n'
        const csvString = [
            [title],
            ['catalogo',
                ...Object.values(mapdatacow_dict).map(c => c.label),
                ...Object.values(mapdatacowman_dict).map(c => c.label),
                ...Object.values(mapdataproperty_dict).map(c => c.label),
            ],
            ...cow_list.sort(propComparator('catalog_id')).map(cow => {

                let c_list = [cow.catalog_id || '']
                for (const cp in mapdatacow_dict) {
                    const p = mapdatacow_dict[cp]
                    let v = ''
                    if (cow[cp]) {
                        if (p.type === 'date') {
                            v = myFormat(cow[cp])
                        } else {
                            v = cow[cp]
                        }
                    }
                    c_list.push(v)

                }
                for (const ccp in mapdatacowman_dict) {
                    let v = ''
                    if (cow.cowman && cow.cowman[ccp]) {
                        v = cow.cowman[ccp]
                    }
                    c_list.push(v)
                }
                for (const ccp in mapdataproperty_dict) {
                    let v = ''
                    if (cow.property && cow.property[ccp]) {
                        v = cow.property[ccp]
                    }
                    c_list.push(v)
                }
                return c_list
            })
        ]
            .map(row => row.join(";"))
            .join(end);
        console.log(csvString)
        const blob = new Blob([csvString], { type: 'text/csv' });
        // Generate a download link and initiate the download
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'catalogo' + fileName || 'export_data.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }



    return (
        <>

            <MenuItem disabled={data.length === 0} onClick={() => downloadCSV('unix')} disableRipple>
                <ListItemIcon>
                    <SendAndArchive />
                </ListItemIcon>
                Esporta CSV assicurazione (presenti) [unix]
            </MenuItem>
            <MenuItem disabled={data.length === 0} onClick={() => downloadCSV('dos')} disableRipple>
                <ListItemIcon>
                    <SendAndArchive />
                </ListItemIcon>
                Esporta CSV assicurazione (presenti) [dos]
            </MenuItem>
            <MenuItem disabled={data.length === 0} onClick={() => downloadCowlistWithCatalog('unix')} disableRipple>
                <ListItemIcon>
                    <SendAndArchive />
                </ListItemIcon>
                Esporta CSV soggetti con numero catalogo [unix]
            </MenuItem>
            <MenuItem disabled={data.length === 0} onClick={() => downloadCowlistWithCatalog('dos')} disableRipple>
                <ListItemIcon>
                    <SendAndArchive />
                </ListItemIcon>
                Esporta CSV soggetti con numero catalogo [dos]
            </MenuItem>
        </>
    )
    //    return <button onClick={downloadCSV}>Esporta CSV assicurazione</button>;
};

export default ExportCSV;